module.exports = __webpack_public_path__ + "static/media/wind.341a1f5b.svg";